import React from 'react';
import { Link } from 'react-router-dom';
import './TalkToExpert.css';

const TalkToExpert = () => {
  return (
    <section className="talk-to-expert">
      <div className="container">
        <div className="expert-card">
          <div className="expert-content">
            <h2 className="expert-title">Need Expert Consultation?</h2>
            <p className="expert-description">
              Get personalized IT solutions tailored to your business needs. 
              Our certified experts are ready to help you make the right technology decisions.
            </p>
            <div className="expert-features">
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>Free Initial Consultation</span>
              </div>
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>8 X 6 Technical Support</span>
              </div>
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>Certified IT Professionals</span>
              </div>
            </div>
            <Link to="/contact" className="btn btn-expert">
              <span className="btn-text">Talk to Expert</span>
              <span className="btn-icon">💬</span>
            </Link>
          </div>
          <div className="expert-visual">
            <div className="expert-illustration">
              <div className="expert-avatar">👨‍💼</div>
              <div className="chat-bubbles">
                <div className="bubble bubble-1">Hi! How can I help?</div>
                <div className="bubble bubble-2">Let's discuss your IT needs</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TalkToExpert;
